.title {
  font-weight: 500;
}

.content {
  flex-direction: column;
  flex-grow: 1;
}
